<template>
  <div class="full-calendar-header">
    <div class="header-left">
      <slot name="header-left">
      </slot>
    </div>
    <div class="header-center row clearfix">
      <div class="prev-month col-md-3 column" @click.stop="goPrev"><img v-show="!isPrint" style="height: 20px;float:right;" src="@/assets/button/triangle_blue_left_button.png"/></div>
      <div class="F3-M-27 col-md-6 column"><span v-show="isPrint">[出力]</span>{{title}}</div>
      <div class="next-month col-md-3 column" @click.stop="goNext"><img v-show="!isPrint" style="height: 20px;float:left" src="@/assets/button/triangle_blue_right_button.png"/></div>
    </div>
    <div class="header-right">
      <slot name="header-right">
      </slot>
    </div>
  </div>
</template>
<script type="text/babel">
import moment from 'moment'

export default {
  props: {
    currentMonth: {},
    titleFormat: {},
    firstDay: {},
    monthNames: {},
    locale: {},
    isPrint: false
  },
  data () {
    return {
      leftArrow: '<',
      rightArrow: '>'
    }
  },
  computed: {
    title () {
      if (!this.currentMonth) return
      this.$store.commit('SET_YEARANDMONTH', (this.currentMonth.locale(this.locale).format('YYYYMM')))
      return this.currentMonth.locale(this.locale).format('YYYY年 M月')
    }
  },
  methods: {
    goPrev () {
      var newMonth = moment(this.currentMonth).subtract(1, 'months').startOf('month')
      this.$emit('change', newMonth)
    },
    goNext () {
      var newMonth = moment(this.currentMonth).add(1, 'months').startOf('month')
      this.$emit('change', newMonth)
    }
  }
}
</script>
<style lang="scss" scoped>
.full-calendar-header{
  display: flex;
  align-items: center;
  .header-left,.header-right{
    flex:1;
  }
  .header-center{
    flex:1;
    text-align:center;
    display: flex;
    align-items: center;
    font-size: 28px;
    .prev-month,.next-month{
      cursor: pointer;
    }
  }
  @media screen and (max-device-width: 1480px) {
  .header-center{
      font-size: 24px;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue